/**
 * HTTP到HTTPS重定向插件
 * 在生产环境中，如果用户通过HTTP访问，自动重定向到HTTPS
 */
export default defineNuxtPlugin(() => {
  // 只在客户端执行
  if (process.client) {
    // 只在生产环境中执行
    const isProduction = process.env.NODE_ENV === 'production';
    
    const isLocalPreview = ['localhost', '127.0.0.1'].includes(window.location.hostname);

    if (isProduction && !isLocalPreview) {
      // 检查当前协议是否为HTTP
      if (window.location.protocol === 'http:') {
        // 构建HTTPS URL，保留路径、查询参数和哈希
        const httpsUrl = `https://${window.location.host}${window.location.pathname}${window.location.search}${window.location.hash}`;
        console.log(`[HTTPS Redirect] Redirecting from HTTP to: ${httpsUrl}`);
        
        // 执行重定向
        window.location.replace(httpsUrl);
      }
    }
  }
});
